
import { Database } from '@/integrations/supabase/types';

// Raw database type
export type BlogPostRow = Database['public']['Tables']['blog_posts']['Row'];

// Frontend-friendly type with author object
export type BlogPost = BlogPostRow & {
  author?: {
    full_name: string;
    username: string;
    avatar_url?: string;
  };
};

// Form-friendly type adapter
export type BlogPostForm = Omit<BlogPost, 'id' | 'created_at' | 'updated_at'> & {
  summary: string;
  featured_image: string;
};

// Transform function to convert database row to frontend-friendly BlogPost
export const transformBlogPost = (row: BlogPostRow): BlogPost => {
  return {
    ...row,
    author: {
      full_name: row.author_name || 'Unknown Author',
      username: row.author_id || 'unknown',
      avatar_url: undefined
    }
  };
};
